export default __webpack_public_path__ + "static/media/hero.4aa1bdef.webp";